/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { errorInteractions } from '../../../analytics';

export default (set, get, errorObject, primaryCategory, eventName) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const trackErrorInteractions = { errorObject, primaryCategory, eventName };

  draft.digitalData.errorInteractions = trackErrorInteractions;

  errorInteractions(trackErrorInteractions);
}), false, { type: 'TRACK_PAGE_ERROR_INTERACTIONS' });
